import React from 'react';
import styles from './ReactNative.less';
import _ from 'root/libs/exaforte/react/lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

export const Platform = {'OS': 'browser'};

export class View extends React.Component {
    render() {
        let supportedProps = filterSupportedProps(this.props);
        
        if(supportedProps.className && typeof this.props.className != 'string')
            supportedProps.className = this.props.className.join(' ');
        
        if(supportedProps.forwardedRef)
            delete supportedProps.forwardedRef;
        
        return <div {...{...supportedProps , ...(this.props.forwardedRef ? {ref: this.props.forwardedRef} : {})}}>{this.props.children}</div>;
    }
}

export class Link extends React.Component {
    render() {
        let supportedProps = filterSupportedProps(this.props);
        
        if(supportedProps.className && typeof this.props.className != 'string')
            supportedProps.className = this.props.className.join(' ');
        
        return (
            <a {...supportedProps}>{this.props.children}</a>
        );
    }
}

export class SafeAreaView extends View {
    
}

export class Image extends View {
    render() {
        let supportedProps = filterSupportedProps(this.props);
        
        if(supportedProps.className && typeof this.props.className != 'string')
            supportedProps.className = this.props.className.join(' ');
        
        if(this.props.native)
            return <img src={this.props.source} {...supportedProps} />;
        
        if(!supportedProps.style)
            supportedProps.style = {};

        supportedProps.style['backgroundImage'] = 'url(' + this.props.source + ')';
            
        switch(this.props.resizeMode)
        {
            case 'contain':
            case 'cover':
            case 'stretch':
                supportedProps.style['backgroundSize']      = this.props.resizeMode;
                supportedProps.style['backgroundPosition']  = this.props.position || 'center';
            break;
            case 'repeat':
                supportedProps.style['backgroundRepeat'] = this.props.resizeMode;
            break;
            case 'center':
                supportedProps.style['backgroundPosition'] = this.props.resizeMode;
            break;
            default:
                supportedProps.style['backgroundRepeat'] = 'no-repeat';
            break;
        }
        
        return (
            <div {...supportedProps}>{this.props.children}</div>
        );
    }
}

export class Text extends View {
    
}

export class TouchableOpacity extends View {
    constructor(props)
    {
        super(props);
    
        this.state      = { touched: false};
        this._isMounted = false;
    }
    
    componentDidMount() {
        this._isMounted = true;
    }
    
    toggleTouched = (e) => {
        if(this._isMounted && e && e.nativeEvent && e.nativeEvent.which == 1)
            this.setState( prevState => ({
                touched: !prevState.touched
            }));
    }
    
    handleMouseUp = (e) => {
        setTimeout( () => {
            if(this._isMounted && this.state.touched)
                this.setState({ touched: false });
        }, 150);
    }
    
    componentWillUnmount() {
        this._isMounted = false;
    }
    
    render () {
        let props = filterSupportedProps(this.props);
        
        if(!props.className)
            props.className = [];
        
        if(!props.className.includes(styles.button))
            props.className.unshift(styles.button);

        if(this.state.touched)
            props.className.unshift(styles['button-clicked']);
        else
            _.pull(props.className, styles['button-clicked']);

        if(this.props.animateClick)
        {
            props.onMouseDown   = this.toggleTouched;
            props.onMouseUp     = this.handleMouseUp;
        }

        return (
            <View {...props} onClick={this.props.onPress}>{this.props.children}</View>
        )
    }
}

export class TouchableNativeFeedback extends TouchableOpacity {
    
}

export class ActivityIndicator extends React.Component {
    render() {
        let supportedProps = filterSupportedProps(this.props);
        
        if(supportedProps.className && typeof this.props.className != 'string')
            supportedProps.className = this.props.className.join(' ');
        
        if(this.props.size)
            supportedProps.style = {fontSize: this.props.size};
        
        return (
            <FontAwesomeIcon icon={faSpinner} {...supportedProps} spin />
        );
    }
}

export FlatList from 'flatlist-react';


const supportedProps = {
  accessibilityLabel: true,
  accessibilityLiveRegion: true,
  accessibilityRole: true,
  accessibilityStates: true,
  accessible: true,
  children: true,
  className: true,
  disabled: true,
  importantForAccessibility: true,
  nativeID: true,
  onBlur: true,
  onContextMenu: true,
  onFocus: true,
  onMoveShouldSetResponder: true,
  onMoveShouldSetResponderCapture: true,
  onResponderEnd: true,
  onResponderGrant: true,
  onResponderMove: true,
  onResponderReject: true,
  onResponderRelease: true,
  onResponderStart: true,
  onResponderTerminate: true,
  onResponderTerminationRequest: true,
  onScrollShouldSetResponder: true,
  onScrollShouldSetResponderCapture: true,
  onSelectionChangeShouldSetResponder: true,
  onSelectionChangeShouldSetResponderCapture: true,
  onStartShouldSetResponder: true,
  onStartShouldSetResponderCapture: true,
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true,
  pointerEvents: true,
  style: true,
  testID: true,
  forwardedRef: true,
  /* @platform web */
  onScroll: true,
  onWheel: true,
  dangerouslySetInnerHTML: true,
  // keyboard events
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  // mouse events (e.g, hover effects)
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOver: true,
  onMouseOut: true,
  onMouseUp: true,
  // unstable escape-hatches for web
  href: true,
  itemID: true,
  itemRef: true,
  itemProp: true,
  itemScope: true,
  itemType: true,
  onClick: true,
  onClickCapture: true,
  rel: true,
  target: true,
  
  //activity ActivityIndicator
  spin: true,
  size: true,
  onTransitionEnd: true,
};

const filterSupportedProps = props => {
  const safeProps = {};
  for (const prop in props) {
    if (props.hasOwnProperty(prop)) {
      if (supportedProps[prop] || prop.indexOf('aria-') === 0 || prop.indexOf('data-') === 0) {
          if(typeof props[prop] == 'int')
            safeProps[prop] = props[prop] + '';
        else
            safeProps[prop] = props[prop];
            
      }
    }
  }
  return safeProps;
};